import page24 from "./Page24.webp";
import page25 from "./Page25.webp";
import page26 from "./Page26.webp";
import page27 from "./Page27.webp";
import page28 from "./Page28.webp";
import page29 from "./Page29.webp";
import page30 from "./Page30.webp";
import page31 from "./Page31.webp";

export const japandiPages = [
  page24,
  page25,
  page26,
  page27,
  page28,
  page29,
  page30,
  page31,
];
